export enum DownloadStatusesType {
  Ok,
  Error,
  Loading,
  None,
}

export type ResultMessageType = {
  text: string;
  status: DownloadStatusesType;
};
